const convertRoiCalculatorFieldNameToGoogleAnalyticsEventName = require("./convertRoiCalculatorFieldNameToGoogleAnalyticsEventName");
const triggerCustomGoogleAnalyticsEvent = require(".././googleAnalytics/triggerCustomGoogleAnalyticsEvent");

/**
 * @param fieldName {string}
 * @return {void}
 */
module.exports = function triggerGoogleAnalyticsEventForRoiCalculatorFormField(fieldName) {
    const googleAnalyticsEvent = convertRoiCalculatorFieldNameToGoogleAnalyticsEventName(fieldName);

    if (googleAnalyticsEvent) {
        triggerCustomGoogleAnalyticsEvent(googleAnalyticsEvent);
    }
}
